import { images } from "../../constants";

export const ImageInsurance = ({ provider }) => {
  return (
    <>
      {provider === "OSHC" && (
        <img style={{ width: "100%" }} src={images.OSHC} alt="" />
      )}
      {provider === "CBHS" && (
        <img style={{ width: "100%" }} src={images.CBHS} alt="" />
      )}
      {provider === "nib" && (
        <img style={{ width: "100%" }} src={images.nib} alt="" />
      )}
      {provider === "Allianz Care" && (
        <img style={{ width: "100%" }} src={images.allianz} alt="" />
      )}
      {provider === "Medibank" && (
        <img style={{ width: "100%" }} src={images.Medibank} alt="" />
      )}
      {provider === "Bupa" && (
        <img style={{ width: "100%" }} src={images.Bupa} alt="" />
      )}
    </>
  );
};
